import { FormControl, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import { Formik } from '@/types';
import { useSeries } from '@/features/list-serie/api/getSerie.ts';
import { SerieModel } from '@/features/list-serie/types';

type ListSerieProps = {
  formik: Formik | any;
  name: string;
  required?: boolean;
}

const ListSerie: React.FC<ListSerieProps> = ({ formik, name, required = true }) => {

  const { data } = useSeries();
  const error = required && formik.touched[name] && formik.errors[name];

  return (
    <FormControl sx={{ '.MuiSvgIcon-root': { color: 'rgba(68, 68, 68, 1)' } }} fullWidth error={error}>
      <Typography mb={'7px'}>Série*</Typography>
      <Select
        id={name}
        name={name}
        required
        sx={{ color: '#000', border: '1px solid #000' }}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched[name] && !!formik.errors[name]}
      >
        <MenuItem key={''} value={null}>{''}</MenuItem>
        {
          data?.map((item: SerieModel) => <MenuItem
                key={String(item.serie_nome)}
                value={item.serie_nome}>{`${item.serie_nome}`}</MenuItem>)
        }
      </Select>
      {
        formik.touched[name] &&
        formik.errors[name] &&
        <FormHelperText>{formik.errors[name]}</FormHelperText>
      }
    </FormControl>
  );
};

export default ListSerie;